import request from '@/utils/request'

export function getHomeGateWayList(data) {
  return request({
    url: 'api/getHomeGateWayList',
    method: 'post',
    params: data
  })
}
export function getHDLUnauthorizedHomeList(data) {
  return request({
    url: 'api/getHDLUnauthorizedHomeList',
    method: 'post',
    params: data
  })
}
export function deliveryUser(data) {
  return request({
    url: 'api/deliveryUser',
    method: 'post',
    params: data
  })
}
export function updateHomeName(data) {
  return request({
    url: 'api/updateHomeName',
    method: 'post',
    params: data
  })
}
export function getDeviceList(data) {
  return request({
    url: 'api/getDeviceList',
    method: 'post',
    params: data
  })
}
export function getClientUserList(data) {
  return request({
    url: 'api/getClientUserList',
    method: 'post',
    params: data
  })
}
export function gatewayBindUser(data) {
  return request({
    url: 'api/gatewayBindUser',
    method: 'post',
    params: data
  })
}
export function delGatewayHome(data) {
  return request({
    url: 'api/delGatewayHome',
    method: 'post',
    params: data
  })
}
